export enum DeclarationSynchronizationStatus {
  /** Aucun suivi de synchronisation actif dans l'interface. */
  NotStarted = 'notStarted',
  /** Les pièces jointes sont indexées pour obtenir leurs URI distantes. */
  IndexingAttachments = 'indexingAttachments',
  /** Les déclarations sont envoyées vers l'API de synchronisation. */
  SynchronizingDeclaration = 'synchronizingDeclaration',
  /** Le contenu des pièces jointes est envoyé vers le stockage distant. */
  UploadingAttachments = 'uploadingAttachments',
  /** Toutes les étapes de synchronisation sont terminées avec succès. */
  Completed = 'completed',
  /** Une étape de synchronisation a échoué. */
  Failed = 'failed',
}
